window.EasyVue ||= {};
window.EasyVue.editProject = async (id: string, data: unknown, reloadAfterSuccess?: boolean) => {
  const { editProject } = await import("../src/projects/index");
  window.EasyVue.editProject = editProject;
  editProject(id, data, reloadAfterSuccess);
};
